import { ExpandLessIcon, ExpandMoreIcon } from '../../../icons'
import './expandable-section.scss'

const ExpandableSection = (props) => {
  const { isExpanded, onToggle, title, className, additionalContent, children } = props

  return (
    <div className={'expandable-section' + (className ? ` ${className}` : '')}>
      <div className={`expand-header ${isExpanded ? 'highlight' : 'border-bottom'}`} onClick={onToggle}>
        <div className="title-wrapper">
          <div className="title">{title}</div>
          {additionalContent}
        </div>
        <div className="icon">{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
      </div>
      {isExpanded && <div className="expand-body">{children}</div>}
    </div>
  )
}

export default ExpandableSection
